import Firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import ReactGA from 'react-ga4';

import ORDER_STATUS from './helpers/STATUS';

const transitions = {
  [ORDER_STATUS.inProgress]: {
    from: ORDER_STATUS.inValidation,
    fields: ['status', 'acceptedAt', 'estimatedTimeToDeliver'],
  },
  [ORDER_STATUS.ready]: {
    from: ORDER_STATUS.inProgress,
    fields: ['status', 'readyAt'],
  },
  [ORDER_STATUS.inDelivery]: {
    from: ORDER_STATUS.ready,
    fields: ['status', 'pickedAt'],
  },
};

const updateOrder = async (order, data) => {
  if (!Firebase.auth().currentUser) {
    throw new Error('Vous devez être connecté pour modifier une commande.');
  }
  if (!order?.id || !data || typeof data !== 'object' || Array.isArray(data)) {
    throw new Error('Modification de commande invalide.');
  }

  const keys = Object.keys(data);
  const isAssignment = keys.length === 1 && keys[0] === 'rusher';
  const transition = Object.prototype.hasOwnProperty.call(
    transitions,
    data.status
  )
    ? transitions[data.status]
    : null;
  if (
    !isAssignment &&
    (!transition || keys.some(key => !transition.fields.includes(key)))
  ) {
    throw new Error('Transition de commande invalide.');
  }
  if (isAssignment) {
    if (
      data.rusher !== null &&
      (typeof data.rusher !== 'object' ||
        Array.isArray(data.rusher) ||
        typeof data.rusher.id !== 'string' ||
        !data.rusher.id.trim())
    ) {
      throw new Error('Livreur invalide.');
    }
  } else if (
    keys.some(
      key =>
        key !== 'status' &&
        (typeof data[key] !== 'number' ||
          !Number.isFinite(data[key]) ||
          data[key] < 0)
    )
  ) {
    throw new Error('Données de transition invalides.');
  }

  ReactGA.event({ category: 'Order', action: 'Update order' });
  const db = Firebase.firestore();
  const ref = db.collection('orders').doc(order.id);
  return db.runTransaction(async transaction => {
    const snapshot = await transaction.get(ref);
    if (!snapshot.exists) throw new Error("Cette commande n'existe pas.");
    const current = snapshot.data();
    if (current.inTreatment) {
      throw new Error('Commande en cours de traitement, réessayez plus tard.');
    }

    if (isAssignment) {
      if (
        ![ORDER_STATUS.inProgress, ORDER_STATUS.ready].includes(current.status)
      ) {
        throw new Error('Attribution impossible dans cet état de commande.');
      }
      if (data.rusher !== null && current.rusher) {
        throw new Error('Cette commande est déjà attribuée à un livreur.');
      }
      if (
        data.rusher === null &&
        (!order.rusher?.id || current.rusher?.id !== order.rusher.id)
      ) {
        throw new Error('Le livreur a changé, actualisez la commande.');
      }
    } else {
      if (current.status !== transition.from) {
        throw new Error(
          'Le statut de cette commande ne permet plus cette transition.'
        );
      }
      if (
        data.status === ORDER_STATUS.inDelivery &&
        (!order.rusher?.id || current.rusher?.id !== order.rusher.id)
      ) {
        throw new Error(
          'Le livreur est absent ou a changé, actualisez la commande.'
        );
      }
    }

    transaction.update(ref, {
      ...data,
      updatedAt: Firebase.firestore.FieldValue.serverTimestamp(),
    });
    return {
      success: true,
      status: isAssignment ? current.status : data.status,
    };
  });
};

export default updateOrder;
